if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.content = this.querySelector('[role="document"]');
      this.touchStart = null;
      this.counter = this.querySelector('[data-modal-counter]');

      this.querySelectorAll('[data-modal-nav], .product-media-modal__thumbs').forEach((control) => {
        control.addEventListener('pointerup', (event) => event.stopPropagation());
      });
      this.content?.addEventListener('pointerup', (event) => event.stopPropagation());

      this.addEventListener('click', (event) => {
        const navigationButton = event.target.closest('[data-modal-nav]');
        if (navigationButton) {
          this.navigateMedia(navigationButton.dataset.modalNav === 'next' ? 1 : -1);
          return;
        }

        const thumbnail = event.target.closest('[data-modal-thumb]');
        if (thumbnail) this.showMediaById(thumbnail.dataset.modalThumb);
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') this.navigateMedia(1);
        if (event.key === 'ArrowLeft') this.navigateMedia(-1);
      });

      this.content?.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch') return;
        this.touchStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
      }, { passive: true });
      this.content?.addEventListener('pointerup', (event) => {
        if (!this.touchStart || this.touchStart.id !== event.pointerId) return;
        const deltaX = event.clientX - this.touchStart.x;
        const deltaY = event.clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(deltaX) > 54 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
          this.navigateMedia(deltaX < 0 ? 1 : -1);
        }
      }, { passive: true });
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.showMediaById(this.openedBy.getAttribute('data-media-id'));
    }

    showMediaById(mediaId) {
      const activeMedia = this.querySelector(`[role="document"] > [data-media-id="${mediaId}"]`);
      if (!activeMedia) return;

      this.querySelectorAll('[role="document"] > [data-media-id]').forEach((item) => {
        item.classList.toggle('active', item === activeMedia);
      });
      this.querySelectorAll('[data-modal-thumb]').forEach((thumbnail) => {
        const isCurrent = thumbnail.dataset.modalThumb === String(mediaId);
        thumbnail.classList.toggle('is-current', isCurrent);
        if (isCurrent) thumbnail.setAttribute('aria-current', 'true');
        else thumbnail.removeAttribute('aria-current');
      });

      this.hydrateMedia(activeMedia);
      const items = Array.from(this.querySelectorAll('[role="document"] > [data-media-id]'));
      const currentIndex = items.indexOf(activeMedia);
      if (this.counter) this.counter.textContent = `${Math.max(0, currentIndex) + 1} / ${items.length}`;
      this.content?.scrollTo({ left: 0, top: 0, behavior: 'auto' });
    }

    hydrateMedia(media) {
      const image = media.matches('img[data-modal-image]') ? media : media.querySelector('img[data-modal-image]');
      if (image && image.dataset.modalSrc) {
        const galleryPreview = document
          .querySelector(`modal-opener button[data-media-id="${media.dataset.mediaId}"]`)
          ?.closest('modal-opener')
          ?.querySelector('img');
        if (galleryPreview?.currentSrc) image.src = galleryPreview.currentSrc;
        image.classList.add('is-loading');
        image.addEventListener('load', () => image.classList.remove('is-loading'), { once: true });
        if (image.dataset.modalSrcset) image.srcset = image.dataset.modalSrcset;
        image.src = image.dataset.modalSrc;
        delete image.dataset.modalSrcset;
        delete image.dataset.modalSrc;
      }

      const template = media.querySelector('template');
      const templateContent = template ? template.content : null;
      if (media.nodeName === 'DEFERRED-MEDIA' && templateContent?.querySelector('.js-youtube')) {
        media.loadContent();
      }
    }

    navigateMedia(direction) {
      const items = Array.from(this.querySelectorAll('[role="document"] > [data-media-id]'));
      if (items.length < 2) return;
      let index = items.findIndex((item) => item.classList.contains('active'));
      if (index < 0) index = 0;
      const next = items[(index + direction + items.length) % items.length];
      this.showMediaById(next.dataset.mediaId);
    }
  });
}
